export default __webpack_public_path__ + "static/media/nait.fc8c414f.svg";